import React from 'react';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { Translations } from '../../../../types/translation/common';
import { toFilterString } from '../../../../util/string.util';
import { BaseFilter } from '../common/BaseFilter';

export class TranslationFilter extends BaseFilter<TranslationKey> {
  english: Translations;
  current: Translations;

  constructor(english: Translations, current: Translations = {} as Translations) {
    super();
    this.english = english;
    this.current = current;
  }

  toLabel(): string {
    return '';
  }

  toCount(): number {
    return 0;
  }

  toIcon(): JSX.Element {
    return <></>;
  }

  toDropdownContent(): JSX.Element {
    return <></>;
  }

  toInnerContent(): string | JSX.Element {
    return <></>;
  }

  search(key: TranslationKey, textFilter: string) {
    textFilter = toFilterString(textFilter);
    if (toFilterString(key).includes(textFilter)) return true;

    const englishRecord = this.english[key];
    if (englishRecord) {
      if (toFilterString(englishRecord.singular.lower).includes(textFilter)) return true;
      if (toFilterString(englishRecord.plural.lower).includes(textFilter)) return true;
    }

    const currentRecord = this.current[key];
    if (currentRecord) {
      if (toFilterString(currentRecord.singular.lower).includes(textFilter)) return true;
      if (toFilterString(currentRecord.plural.lower).includes(textFilter)) return true;
    }

    return false;
  }
}
